<template>
    <div class="login">
        <div class="background">
            <div class="backgroundimg" :style="height">
                <img src="../../assets/images/login/icon02.jpg" alt="">
            </div>
            <div class="background-text">
                <span class="">
                    天无信，四时失序
                </span>
                <span>
                    人有信，行止可立
                </span>
            </div>
        </div>
        <div class="main">
            <div class="title">天信意健险系统 </div>
            <div class="sect">
                <!-- <div class="sect-tit">
                    管理者登录
                </div> -->
                <div class="item">
                    <!-- <div class="item-tit">账户名:</div> -->
                    <div class="input">
                        <el-input prefix-icon="el-icon-user-solid" v-model="signInData.phone" placeholder="请输入账户名"></el-input>
                    </div>
                </div>
                <div class="item">
                    <!-- <div class="item-tit">密码:</div> -->
                    <div class="input">
                        <el-input prefix-icon="el-icon-unlock" v-model="signInData.password" placeholder="请输入密码" type="password"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="input" style="display: flex; align-items: center; gap: 10px;">
                        <el-input prefix-icon="el-icon-circle-check" v-model="inputCode" placeholder="请输入验证码"
                            style="flex: 1;"></el-input>
                        <canvas id="s-canvas" :width="contentWidth" :height="contentHeight" @click="drawPic"
                            style="cursor: pointer; border-radius: 4px;"></canvas>
                    </div>
                </div>
                <el-button type="primary" class="btn" @click="signIn">登录</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../api/login'
export default {
    name: 'login',
    data () {
        return {
            height:'',
            signInData:{
            },
            // --- 验证码相关配置 ---
            inputCode: '', // 用户输入的验证码
            identifyCode: '', // 生成的验证码原文
            identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", // 备选字符
            contentWidth: 112,
            contentHeight: 38,
        }
    },
    created(){
        

    },
    mounted(){
        this.getHeight();
        this.drawPic(); // 初始化验证码
    },
    methods:{
        //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
                console.log(_this.height);
                // 是否全屏
                // if(!_this.isFullScreen){
                //     _this.isFullScreen=true;
                // }
            }
        },

        // 生成随机数（保持原样，用于抽取字符）
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        
        // 绘制验证码图片
        drawPic() {
            this.identifyCode = "";
            // 随机生成4位
            for (let i = 0; i < 4; i++) {
                this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
            }

            let canvas = document.getElementById('s-canvas');
            let ctx = canvas.getContext('2d');
            
            // 1. 【化简】使用固定淡色背景，不晃眼
            ctx.fillStyle = '#f4f4f5'; 
            ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
            
            // 2. 绘制文字
            for (let i = 0; i < this.identifyCode.length; i++) {
                this.drawText(ctx, this.identifyCode[i], i);
            }
            
            // 3. 【化简】减少干扰，只留 1 条清爽的干扰线（如果你完全不想要，可以把这两行也删掉）
            this.drawSimpleLine(ctx);
        },
        
        // 绘制文字
        drawText(ctx, txt, i) {
            // 【化简】使用固定清晰的深蓝色，字体大小固定
            ctx.fillStyle = '#0f85ff'; 
            ctx.font = 'bold 24px Helvetica, Arial, sans-serif';
            ctx.textBaseline = 'middle'; // 垂直居中对齐

            // 【化简】平均分配 X 轴坐标，Y 轴直接居中，文字不再旋转，保证极高可读性
            let x = (i * 24) + 15; 
            let y = this.contentHeight / 2;

            ctx.fillText(txt, x, y);
        },
        
        // 【化简】极简干扰线
        drawSimpleLine(ctx) {
            ctx.strokeStyle = 'rgba(15, 133, 255, 0.2)'; // 半透明线条
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(0, this.randomNum(10, this.contentHeight - 10));
            ctx.lineTo(this.contentWidth, this.randomNum(10, this.contentHeight - 10));
            ctx.stroke();
        },

        //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
            }
        },
        
        async signIn() {
            if (!this.inputCode) {
                this.$message.error('请输入验证码');
                return;
            }
            if (this.inputCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
                this.$message.error('验证码错误');
                this.drawPic(); 
                return;
            }

            let data = await api.signIn(this.signInData);
            if(data.data.code == '200') {
                localStorage.setItem('accessToken', data.data.data.token);
                localStorage.setItem('name', data.data.data.name);
                localStorage.setItem('mechanismid', data.data.data.mechanismid);
                localStorage.setItem('mechanism', data.data.data.mechanism);
                localStorage.setItem('primaryToken', data.data.data);
                localStorage.setItem('roleStr', JSON.stringify(data.data.data.roles));
                this.$router.push({ path:'/main' });
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .login{
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        overflow: hidden;
        position:relative;
        .background{
            position:relative;
            overflow: hidden;
            height: 100%;
            flex: 1;
            .backgroundimg{
                overflow: hidden;
                img{
                    width: 100%;
                    // height: 100%;
                    // min-width: 1533px;
                    // min-height: 1000px;
                    min-width: 1500px;
                    // height: 1000px;
                }
            }
            .background-text{
                position: absolute;
                top: 320px;
                left: 70px;
                color: #ffffff;
                display: flex;
                flex-direction: column;
                font-size: 88px;
                line-height: 110px;
                font-weight: bold;
            }
        }
        .main{
            width: 466px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                font-size: 32px;
                color: #0f85ff;
                text-align: center;
                margin-bottom: 20px;
                font-weight: bold;
            }
            .sect{
                // background-color: rgba(255, 255, 255, 0.4);
                border-radius: 10px;
                .sect-tit{
                    font-size: 20px;
                    text-align: center;
                    color: #0f85ff;
                    font-weight: bold;
                    letter-spacing:5px;
                    display: flex;
                    justify-content: space-around;
                    margin-bottom: 30px;
                    .t-item{
                        color: #ffffff;
                        cursor: pointer;
                    }
                    .t-item-this{
                        color: #1250ea;
                        border-bottom: 2px solid #1250ea;
                        
                        padding-bottom: 10px;
                        
                    }
                }
                .item{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 15px;
                    .item-tit{
                        font-size: 18px;
                        margin-left: 3px;
                    }
                    .input{
                        width: 350px;
                    }
                }
                .btn{
                    width: 350px;
                    margin-bottom: 10px;
                    font-weight: bold;
                }
            }
        }
    }
  
</style>
